/**
 * The portal never redeems store credit — it lands on the draft return invoice
 * sent after submission. So a cart that still owes money can be covered later
 * by credit the customer already holds, which is what the notice explains.
 */
export function getApplicableStoreCredit({
  outstandingBalance,
  storeCreditBalance,
}: {
  outstandingBalance: number;
  storeCreditBalance: number;
}): number {
  if (outstandingBalance <= 0 || storeCreditBalance <= 0) {
    return 0;
  }
  return Math.min(outstandingBalance, storeCreditBalance);
}
